import React from "react";
import Slider from "react-slick";
import TitleComponent from "../common/TitleComponent";
import TestimonialsData from "../../models/TestimonialsData";
import TestimonialCard from "../card/TestimonialCard";
import bgImageSrc from "../../assets/images/Backgrounds/achievement-bg.png";
const TestimonialSlider = () => {
  var settings = {
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1370,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <TitleComponent Title={"Our client feedback"} Subtitle={"Testimonials"} />

      <div className="relative shadow-md">
        <img
          alt="floating-icon"
          className="absolute w-full h-full object-cover"
          src={bgImageSrc}
        />

        <div className=" py-10 mb-4 px-9">
          <Slider {...settings}>
            {TestimonialsData.map((TestimonialsCardData) => (
              <TestimonialCard
                key={TestimonialsCardData.id}
                testimonialsCardData={TestimonialsCardData}
              />
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default TestimonialSlider;
